import React from 'react';

const NextSlideButton = ({ onClick, expanded }) => {
  return  (
    <div onClick={onClick} style={{position: 'absolute', bottom: '0', right: '0', background: expanded ? '#25242D' : 'white', padding: '10px 5px 6px', cursor: 'pointer'}}>
      <svg width="30" height="21" viewBox="0 0 30 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_220_257)">
        <path d="M18.7949 1.62256L27.7949 10.6226L18.7949 19.6226" stroke={expanded ? 'white' : "#231F20"} strokeWidth="2" strokeMiterlimit="10"/>
        <path d="M0.794922 10.6226H27.7949" stroke={expanded ? 'white' : "#231F20"} strokeWidth="2" strokeMiterlimit="10"/>
        </g>
        <defs>
          <clipPath id="clip0_220_257">
            <rect width="28.41" height="19.41" fill="white" transform="translate(0.794922 0.912598)"/>
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

export const Slide = ({ onNext, img, title, afterTitleText, expandText, expanded, onClick, href }) => {

  return (
    <>
      <div style={{position: 'relative'}}>
        <img src={img} width="100%" alt="slideImg" style={{width: '100%', height: '100%', aspectRatio: '390 / 500', objectFit: 'cover', objectPosition: 'top', display: 'block',}} />
        {!expanded && (
          <NextSlideButton onClick={onNext} expanded={expanded} />
        )}
      </div>
      <div style={{display: 'flex', flexDirection: 'column', padding: '24px', alignItems: 'flex-start', position: 'relative'}}>
        <div style={{fontSize: '32px', fontWeight: '700', marginBottom: '10px'}}>{title}</div>
        <div style={{fontSize: '18px', textAlign: 'left', fontWeight: expanded ? '700' : '400', marginTop: expanded ? '20px' : '0px'}}>{afterTitleText}</div>
        <div style={{display: expanded ? 'block' : 'none', textAlign: 'left', marginTop: '20px'}}>{expandText}</div>
        <div style={{color: '#25242D', display: 'flex', alignItems: 'center', marginTop: '20px', textDecoration: 'underline', justifyContent: expanded ? 'space-between' : 'flex-start', width: 'calc(100% - 40px)', fontWeight: '700', marginBottom: '20px'}}>
          <span style={{cursor: 'pointer'}} onClick={onClick}>{expanded ? 'Back' : 'Read more'}</span>
          {expanded && <a href={href} target='_blank' rel="noreferrer"  style={{color: '#25242D'}}>More highlights</a>}
        </div>
        {expanded && <NextSlideButton onClick={onNext} expanded={expanded} />}
      </div>
    </>
  );
}